export function getUTCDate(date){
    let utcDate = new Date(
        new Date(date).getUTCFullYear(), 
        new Date(date).getUTCMonth(), 
        new Date(date).getUTCDate());
    return utcDate;
}

export function getUTCDateTime(date){
    let utcDate = new Date(
        new Date(date).getUTCFullYear(), 
        new Date(date).getUTCMonth(), 
        new Date(date).getUTCDate(),
        new Date(date).getHours(),
        new Date(date).getMinutes(),
        new Date(date).getSeconds());
    return utcDate;
}